var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolicitado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C2.46169 0 0 2.46169 0 5.5C0 8.53831 2.46169 11 5.5 11C8.53831 11 11 8.53831 11 5.5C11 2.46169 8.53831 0 5.5 0ZM7.55119 6.94153L7.10764 7.49597C7.07853 7.53236 7.04254 7.56266 7.00172 7.58514C6.9609 7.60763 6.91606 7.62185 6.86974 7.627C6.82342 7.63214 6.77655 7.62812 6.73179 7.61515C6.68703 7.60218 6.64526 7.58052 6.60887 7.55141L5.12298 6.44875C5.01916 6.36563 4.93536 6.26022 4.87778 6.14033C4.82019 6.02045 4.79031 5.88915 4.79032 5.75615V2.30645C4.79032 2.21234 4.82771 2.12209 4.89425 2.05554C4.9608 1.989 5.05105 1.95161 5.14516 1.95161H5.85484C5.94895 1.95161 6.0392 1.989 6.10575 2.05554C6.17229 2.12209 6.20968 2.21234 6.20968 2.30645V5.5L7.49597 6.44254C7.53237 6.47167 7.56269 6.50768 7.58517 6.54853C7.60765 6.58937 7.62186 6.63425 7.62699 6.68059C7.63212 6.72693 7.62806 6.77383 7.61506 6.81861C7.60205 6.86338 7.58035 6.90515 7.55119 6.94153Z",
    fill: "#0064A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitado);
export default __webpack_public_path__ + "static/media/solicitado.4e67e1a2bdf17995f55d760407af2de0.svg";
export { ForwardRef as ReactComponent };